import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "conversation_id", label: "conversation_id" },
    
    { key: "num_chunks", label: "total chunks" },
    { key: "merge_type", label: "merge type" },
    { key: "audio_duration_seconds", label: "audio length (s)" },
    // { key: "merged_audio_s3_url", label: "merged_audio_s3_url", transform: "link" },
    // { key: "output_s3_bucket", label: "output_s3_bucket" }
  ],
};

export default schema;

